































































import { Component, Vue } from "vue-property-decorator";
import { GetSolutionInfo, GetSolutionStatus } from "@/services/solutions/solutionService";
import { SolutionInfo, SolutionTypeEnum } from "@/services/solutions/types";
import { HavePermition, PermitionEnum } from "@/components/security/Permitions";
import { Getter } from "vuex-class";

@Component
export default class SolutionInfoModal extends Vue {
    @Getter("getCurrentUser", { namespace: "authentication" }) getCurrentUser: any;

    solutionInfo = {} as SolutionInfo;
    solutionTypeEnum = SolutionTypeEnum;
    getSolutionStatus = GetSolutionStatus;

    get isAdmin() : boolean {
        return HavePermition(this.getCurrentUser.permissions,
            PermitionEnum[PermitionEnum.AdminPrivilege]);
    }

    open(solutionId: string) {
        GetSolutionInfo(solutionId).then(response => {
            this.solutionInfo = response;
            this.$bvModal.show("modal-solutionInfo");
        });
    }

    hide() {
        this.$bvModal.hide("modal-solutionInfo");
    }

    goToTemplate(templateId: string) {
        return {
            name: "updatetemplate",
            params: { templateId: templateId }
        };
    }
}
